import { render, staticRenderFns } from "./section-blood-oxygen.vue?vue&type=template&id=aa761394&scoped=true"
import script from "./section-blood-oxygen.vue?vue&type=script&lang=js"
export * from "./section-blood-oxygen.vue?vue&type=script&lang=js"
import style0 from "./section-blood-oxygen.vue?vue&type=style&index=0&id=aa761394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa761394",
  null
  
)

export default component.exports